import { useMemo } from "react";
import {
  Paper,
  Typography,
  Box,
} from "@mui/material";
import WGRTable from "./c7Table";


//import WGRTotals from "./iohTotals";

export default function WGRShopGroup({
  shop,
  rows,
}) {
  /*
   * Shop Total
   */
   const totals = useMemo(() => {




    return rows.reduce(      
      (total, row) => (
       
        
        {


        DirectLabour:
          total.DirectLabour +
          Number(row.PRIMECOST_LABOUR || 0),

        OnCostLabour:
          total.OnCostLabour +
          Number(row.Labour_On_Cost || 0),

       
           GrandTotal:
          total.GrandTotal +
          Number(row.Labour_On_Cost || 0)+Number(row.PRIMECOST_LABOUR || 0),

         

         }),

        
          

      {
        DirectLabour: 0,
        OnCostLabour: 0,
        GrandTotal:0
      }
    );
  }, [rows]);

  return (
    <Paper
      elevation={2}
      sx={{
        overflow: "hidden",
        borderRadius: 2,
      }}
    >
      {/* Shop Header */}

      {/* <Box
        sx={{
          bgcolor: "primary.main",
          color: "white",
          px: 2,
          py: 1,
          mt:5,
          minHeight:20,
        }}
      >
        <Typography
          variant="h6"
          fontWeight={700}
        >
          Railway  : {shop}
        </Typography>
      </Box> */}

      {/* Detail Table */}

     

      {/* Shop Total */}
 {/* THIS IS WHERE WGRTable SHOULD BE */}
   <WGRTable
  rows={rows}
  shop={shop}
  totals={totals}
  showTotal={true}
/>
      
        
    </Paper>
  );
}

